export const isDark = () => {
    const htmlElement = document.documentElement;
    const hasDarkClass = htmlElement.classList.contains('dark');
    return hasDarkClass
}